import { inject, Injectable } from '@angular/core';
import { GradeBookThematicBlocksService, ThematicBlockRead } from '@isophi/mng-api';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';

/** Tematické celky of the logged kindergarten, shared by the Třídnice selects and the management modal. */
@Injectable({ providedIn: 'root' })
export class ThematicBlockStoreService {
  private readonly api = inject(GradeBookThematicBlocksService);
  private readonly blocks = new BehaviorSubject<ThematicBlockRead[] | null>(null);

  /** All blocks (archived included, so records keep their label); loads on first subscription. */
  readonly blocks$: Observable<ThematicBlockRead[]> = this.blocks.pipe(
    tap((value) => {
      if (value === null) this.reload();
    }),
    map((value) => value ?? [])
  );

  private loading = false;

  reload(): void {
    if (this.loading) return;
    this.loading = true;
    this.api.thematicBlocksList().subscribe({
      next: (list) => {
        this.loading = false;
        this.blocks.next(list);
      },
      error: () => {
        this.loading = false;
        this.blocks.next([]);
      },
    });
  }

  create(title: string): Observable<ThematicBlockRead> {
    return this.api.thematicBlocksCreate({ title }).pipe(tap((block) => this.upsert(block)));
  }

  update(id: string, changes: { title?: string; archived?: boolean; order?: number }): Observable<ThematicBlockRead> {
    return this.api.thematicBlocksPartialUpdate(id, changes).pipe(tap((block) => this.upsert(block)));
  }

  private upsert(block: ThematicBlockRead): void {
    const list = this.blocks.value ?? [];
    const next = list.some((b) => b.id === block.id) ? list.map((b) => (b.id === block.id ? block : b)) : [...list, block];
    this.blocks.next(next.sort((a, b) => a.order - b.order || a.title.localeCompare(b.title, 'cs')));
  }
}
